<template>
  <div class="absolute inset-0 flex items-center justify-center bg-slate-100 bg-opacity-50">
    <svg class="loader" width="100" height="100" viewBox="25 25 50 50" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="20" fill="none" stroke-width="2" />
    </svg>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useMainStore } from '@/apps/fast/store'

export default {
  data() {
    return {
      confirmationState: null
    }
  },
  computed: {
    ...mapStores(useMainStore)
  }
}
</script>

<style lang="scss" scoped>
@keyframes loading-rotation {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes loading-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124;
  }
}
.loader {
  animation: loading-rotation 1400ms linear infinite;
  margin: 9px 0;

  circle {
    stroke: #006cf1;
    stroke-dasharray: 120;
    stroke-dashoffset: 0;
    transform-origin: center;
    animation: loading-dash 1400ms ease-in-out infinite;
  }
}
</style>
